export default {
  chooseFile: "Seleccione un archivo",
  browse: "Examinar",
  clearFile: "Eliminar el archivo",
  info: "Información",
  requiredField: "El campo es obligatorio",
  at_least_one_field_required: "Debe marcar al menos una opción en esta línea.",
  requiredNumberOrFloat: "Introduzca una cifra entera o decimal",
  emailError: "Introduzca un correo electrónico conforme",
  phoneError: "Introduzca un número de teléfono conforme",
  lastName: "Apellido",
  firstName: "Nombre",
  email: "Correo electrónico",
  address: "Dirección",
  complement: "Complemento",
  postCode: "Código postal",
  city: "Ciudad",
  phone: "Teléfono",
  mobile: "Móvil",
  function: "Función",
  actions: "Acciones",
  rights: "Derechos",
  send: "Enviar",
  errors: "Se han detectado errores",
  form_validation: "Los campos siguientes son obligatorios:",
  entitled: "Título",
  title: "Título",
  selectValue: "Seleccionar un valor",
  uploaded_on: "Publicado el",
  error_file: "Parece que el archivo no está disponible",
  no_skill_error_file: "Esta importación de competencias está vacía",
  download_success: "Archivo descargado correctamente",
  file_downloading: "Descarga en curso...",
  download_file: "Descargar el archivo",
  remove_file: "Eliminar el archivo",
  signed_error: "Vaya, se ha producido un error en el almacenamiento",
  signed_success: "Los cambios han sido guardados correctamente",
  saving: "Almacenamiento en curso",
  confirm: "Confirmar",
  import: "Importar",
  error_nofile: "Debe añadir un archivo",
  error_file_format: "Añada un archivo en el formato correcto",
  error_date: "Introduzca una fecha de inicio anterior a la fecha de finalización",
  link: "Abrir el enlace",
  dateChoice: "Haga clic para elegir una fecha",
  next: "Siguiente",
  pleaseWait: "Espere...",
  select: "Seleccionar",
  cancel: "Cancelar",
  save: "Registrar",
  leave_without_save: "Salir sin guardar",
  leave_confirmation: "¿Está seguro de que desea cerrar sin guardar?",
  ok: "Aceptar",
  edit: "Modificar",
  no: "No",
  yes: "Sí",
  warning: "Atención",
  iConfirm: "Confirmo",
  Save: "Almacenamiento",
  saveFinish: "Almacenamiento finalizado",
  fileFormatError: "Seleccione un archivo en el formato correcto",
  display: "Mostrar",
  elements: "elementos",
  lines: "Líneas",
  conditions: {
    title: "Condición de aplicación del modelo",
    alerte:
      "Por defecto, este modelo se aplica a todos los casos. Si define condiciones a continuación, el modelo solo se aplicará cuando se cumplan todas las condiciones (lógica Y).",
  },
  pagination: {
    to: "para",
    on: "en",
  },
  submit: "Enviar",
  back: "Volver",
  remove: "Eliminar",
  typeYourSearch: "Escriba su búsqueda...",
  sortBy: "Ordenar por",
  order: "Orden",
  desc: "Descendente",
  asc: "Ascendente",
  reset: "Reiniciar",
  filter: "Filtrar",
  Search: "Buscar",
  "No data available in the table": "Ningún dato disponible en la tabla",
  "No data available": "Ningún dato disponible",
  "Please enter or modify your search": "Introduzca o modifique su búsqueda",
  "Please click on the add button": "Haga clic en el botón para añadir",
  search: "Buscar",
  All: "Todos",
  None: "Ninguno",
  "PDF export": "Exportar a PDF",
  "Excel export": "Exportar a Excel",
  "PNG export": "Exportar a PNG",
  "SVG export": "Exportar a SVG",
  "See statistics": "Ver las estadísticas",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Añadir un valor",
    select_option: "",
    no_result: "Ningún resultado coincide con la búsqueda",
    no_options: "Escriba por lo menos {nb} caracteres para buscar resultados...",
  },
  init_search: "Reinicializar la búsqueda",
  search_motor: "Buscador",
  file_size_error: "El archivo es demasiado grande, seleccione uno de menos de ",
  maxTagError: "Respete el número máximo de valores",
  minTagError: "Respete el número mínimo de valores",
  see_more_fields: "Ver más campos",
  justificative_piece: "Justificantes",
  skillRecap: "Resumen de competencias",
  valid: "Valide",
  unlock: "Desbloquear",
  light: "Claro",
  dark: "Oscuro",
  system: "Sistema",
  extensions_accepted: "Seleccione un archivo de tipo pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif o png.",
  tab_error: "Error en esta pestaña",
  regenerate_succes: "¡Identificador regenerado correctamente!",
  password_validation: {
    title: "Introduzca una contraseña que incluya:",
    condition1: "Una letra mayúscula",
    condition2: "Una letra minúscula",
    condition3: "Una cifra",
    condition4: "Un carácter especial",
    condition5: "Mínimo 12 caracteres",
  },
  dropzone: {
    release: "Suelta el archivos aquí para subirlo.",
    drop: "Depositar el archivos aquí o",
    click_here: "clic",
    to_upload: "para subir.",
    downloading: "Descarga en curso...",
    file: "Archivo",
    max_files: "Máximo {count} archivos",
    max_files_message: "Ya ha alcanzado el límite de archivos permitido.",
    max_file_size: "El tamaño del archivo {name} supera el límite permitido.",
    file_extension_error: "La extensión del archivo {name} no es válida.",
    error_title: "Atención: algunos archivos no han sido aceptados.",
    file_size_error: "El tamaño máximo por archivo es de {size} MB.",
  },
  upload_signed_document: {
    label: "Subir el documento firmado",
    one_file: "Debe subir al menos 1 archivo",
    file_only: "Seleccione un archivo PDF",
    overview: "Vista previa",
    close: "Cerrar",
    regenerate: "Regenerar",
    option_value: "Valor",
    option_label: "Etiqueta",
  },
  user_permissions: {
    archive_label: "Ver promociones anteriores",
    profile_label: "Ver todos los perfiles activos",
    search_label: "Buscar...",
    title: "Lista de perfiles del usuario",
    choose_profile: "Elige el perfil que deseas añadir",
  },
  form_error: {
    verify_fields:
      "Algunos campos del formulario contienen errores; por favor, compruébelos y vuelva a enviar el formulario.",
    minimum_value: "Valor mínimo: {value}",
    maximum_value: "Valor máximo: {value}",
  },
};
